export const SET_PICKING_ROUTE_ID = 'SET_PICKING_ROUTE_ID'
export const SET_SKU_ID = 'SET_SKU_ID'
export const SET_MESSAGE_STATUS = 'SET_MESSAGE_STATUS'
export const SET_MESSAGE_COLOR = 'SET_MESSAGE_COLOR'
export const SWITCH_MODAL = 'SWITCH_MODAL'
export const SWITCH_SNACKBAR = 'SWITCH_SNACKBAR'
export const SET_ROWS_PICKING_VALIDATE = 'SET_ROWS_PICKING_VALIDATE'
export const SHOW_MODAL_REPORT_DIFF = 'SHOW_MODAL_REPORT_DIFF'
export const SET_IS_LOADING_GRID = 'SET_IS_LOADING_GRID'
export const SET_BTN_FILTER = 'SET_BTN_FILTER'
export const SET_LOADING_PRINT = 'SET_LOADING_PRINT'
export const SET_PICKING_VALIDATE_PDF = 'SET_PICKING_VALIDATE_PDF'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PAGE_SIZE = 'CHANGE_PAGE_SIZE'
export const SET_TOTAL_ITEMS = 'SET_TOTAL_ITEMS'
export const SET_LOADING_BUTTON = 'SET_LOADING_BUTTON'
export const SHOW_ALERT = 'SHOW_ALERT'
